var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"image-uploader",attrs:{"action":"/api/upload/image","show-file-list":false,"drag":true,"accept":".png,.jpeg,.jpg,.gif","with-credentials":true,"on-success":_vm.uploadSuccess}},[(_vm.previewUrl == null || _vm.previewUrl === '')?_c('p',[_vm._v("拖拽图片到此或点击选择")]):_c('img',{attrs:{"src":_vm.previewUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }